(function () {
  function slugify(text) {
    return text
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');
  }

  document.querySelectorAll('.legal-body h2, .legal-body h3').forEach(function (heading) {
    if (!heading.id && heading.textContent.trim()) {
      heading.id = slugify(heading.textContent);
    }
  });
})();
